import { MDBAlert, MDBBtn, MDBModalFooter } from "mdb-react-ui-kit";
import React, { forwardRef, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { editUser } from "../../../apiclients/streamsapi_bridge";
import { validatePhoneNumber } from "../phonenumbers/AddRemoveNumbers";
const EditExternalNumbr = forwardRef((props, ref) => {
    const { t, i18n } = useTranslation();
    const [extdetails, setExtDetails] = useState({});
    const [editexternal, setEditExternal] = useState([]);
    const [existNumber, setExistNumber] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const [externalTitle, setexternalTitle] = useState(props?.extnumdetails?.title ?? "");
    const { register, formState, handleSubmit, setValue, setError, focus, setFocus, reset, watch } = useForm({
        defaultValues: {
            id: props.extnumdetails.id ? props.extnumdetails.id : 0,
            title: props.extnumdetails.title ? props.extnumdetails.title : '',
            phNum: props.extnumdetails.number ? props.extnumdetails.number : '',
        }
    }
    );

    useEffect(() => {
        if (props) {
            setEditExternal(props.finalEditExternal);
            setExistNumber(props.existexternalNumbers);

        }

    }, props)

    const validateCellPhone = (value) => {
        if (watch("title") && watch("title").trim() !== "Cell Phone" && (value === null || value === "")) {
            return "Phone number should not be empty";
        }
        if (value !== "") {
            return validatePhoneNumber(value);
        }
        return true;
    };

    const onsubmit = async (data) => {
        let errorFlag = false;
        //alert(isDirty)
        if (isDirty) {
            const dirtyFields = formState.dirtyFields;
            existNumber.some((item) => {
                if (item.title === data.title && parseInt(item.id) !== parseInt(props.extnumdetails.id)) {
                    setError("title", { message: "Name should not be duplicate" });
                    errorFlag = true;
                }
                if (parseInt(item.phNumber) === parseInt(data.phNum) && parseInt(item.id) !== parseInt(props.extnumdetails.id)) {
                    setError("phNum", { message: "Phone number should not be duplicate" });
                    errorFlag = true;
                }
            });

            // editexternal.some((item) => {
            //     if (item.title === data.title) {
            //         setError("title", { message: "Name should not be duplicate" });
            //         errorFlag = true;
            //     }
            //     if (parseInt(item.phNumber) === parseInt(data.phNumber)) {
            //         setError("phNumber", { message: "Phone number should not be duplicate" });
            //         errorFlag = true;
            //     }
            // });

            if (!errorFlag) {
                props.setIsloading(true);
                let updates = {
                    reqid: 3,
                    siteid: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).siteid,
                    agentid: props.useragent,
                    external_phnum: {
                        update_phnum: {
                            id: parseInt(props.extnumdetails.id)
                        }


                    },
                    logined_user: JSON.parse(
                        sessionStorage.getItem("admin_session")
                    ).logined_user
                }

                for (const field of Object.keys(dirtyFields)) {
                    // Check if the field is dirty and exists in the data object
                    if (dirtyFields[field] && data.hasOwnProperty(field)) {
                        if (field === 'phNum') {
                            updates.external_phnum.update_phnum[field] = data[field] ? parseInt(data[field]) : undefined;
                        } else {
                            updates.external_phnum.update_phnum[field] = data[field];
                        }


                    }
                }
                // if(modifiedData) {
                //    alert(JSON.stringify(modifiedData));

                // }


                console.log("Update External Number Request data :::::::::::" + JSON.stringify(updates));
                let saverep = await editUser(updates);
                props.setIsloading(false);
                console.log(saverep);
                let saverepeMsg = (saverep.status) ? await saverep.json() : {};
                //alert(saverepeMsg.status);
                console.log("repoonse of the edit xternal ::::::::::::::::::: " + JSON.stringify(saverepeMsg));
                if (saverepeMsg.status && saverepeMsg.status == "success") {
                    props.setSuccessMessage(`External Number ${data.phNum} updated successfully.`);
                    props.setIsExternalModify(true);
                    props.setaddExternalFlag(false);
                    props.setNewExternalNum({
                        title: data.title,
                        phNumber: (data.phNum === null || data.phNum === "") && data.title === "Cell Phone" ? "" : parseInt(data.phNum),
                        id: (data.phNum === null || data.phNum === "") && data.title === "Cell Phone" ? 0 : (parseInt(props.extnumdetails.id) === 0 && saverepeMsg.externalNumId) ? parseInt(saverepeMsg.externalNumId) : parseInt(props.extnumdetails.id)

                    });
                    props.onClose();

                } else {
                    if (saverepeMsg.message?.errors) {
                        if (
                            saverepeMsg.message?.errors[0].errors &&
                            saverepeMsg.message?.errors[0].errors.length > 0
                        ) {
                            saverepeMsg.message?.errors[0].errors.forEach((err) => {
                                if (err.param_name === "logined_user") {
                                    props.setErrorMessage(err.message)
                                    reset();
                                }
                                let errorMsg = err.message, key = (err.param_name).substring(err.param_name.lastIndexOf('.') + 1);
                                setError(key, {
                                    type: "server",
                                    message: errorMsg,
                                });
                                const fieldElement = document.querySelector(
                                    `input[name="${key}"]`
                                );
                                if (fieldElement) {
                                    fieldElement.focus();
                                    //fieldElement.scrollIntoView({ behavior: "smooth" });
                                }
                            });
                        }
                    } else {
                        setInternalError(true);
                    }


                }
            }
        }

    }
    const { errors, isDirty } = formState;
    // useEffect(() => {
    //     if(props) {
    //         setExtDetails(props.extnumdetails);
    //     }

    // },[props])
    return (
        <>
            <form>
                <div>
                    <div className="tel-numbers">
                        <strong>{t("ExtNumberName")}</strong>
                    </div>
                    {extdetails && (
                        <>
                            <div className="form pt-1">
                                <input
                                    maxLength={30}
                                    type="text"
                                    disabled={externalTitle !== "" && externalTitle.trim() === "Cell Phone"}
                                    className="form-control"
                                    {...register("title", { required: "Name should not be empty" })}
                                />
                                {errors.title && (
                                    <p className="text-danger">{errors.title.message}</p>
                                )}
                            </div>
                            <div className="tel-numbers mt-1">
                                <strong>{t("Number")}</strong>
                            </div>
                            <div className="form pt-1">
                                <input
                                    type="text"
                                    className="form-control"
                                    {...register("phNum", {
                                        validate: {
                                            validateCellPhone,

                                        }
                                    })}
                                    onKeyPress={(event) => {
                                        if (!/[0-9]/.test(event.key)) {
                                            event.preventDefault();
                                        }
                                    }}
                                />
                                {errors.phNum && (
                                    <p className="text-danger">{errors.phNum.message}</p>
                                )}
                            </div>
                        </>
                    )}
                </div>

                <div style={{ display: "none" }}>
                    <button ref={ref} onClick={(e) => { e.preventDefault(); handleSubmit(onsubmit)() }}>
                        {t("saveChanges")}</button>
                </div>

                {/* <MDBModalFooter>
                    <MDBBtn color="secondary" onClick={(e) => props.onClose(e)}>
                        {t("cancel")}
                    </MDBBtn>
                    <MDBBtn onClick={(e) => {
                        e.preventDefault();
                        handleSubmit(onsubmit)();
                    }}>{t("saveChanges")}</MDBBtn>
                </MDBModalFooter> */}
            </form>
            {internalError && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="danger"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setInternalError(false)}
                >
                    Internal Server Error
                </MDBAlert>
            )}
        </>
    )
});
export default EditExternalNumbr;